import type { WShopBestsellerProductsTranslations } from "./pl";

export const en: WShopBestsellerProductsTranslations = {
  title: "Bestsellers",
  showAll: "See all",
  noProducts: "No bestsellers.",
};
